import { useState, useEffect } from 'react';
import { fetchDashboardData } from '../services/dashboardService';
import { processVehicleData, processFuelData, processInfractionData, processMaintenanceData } from '../utils/dataProcessors';

export const useDashboardData = () => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [rawData, setRawData] = useState({
    vehiculos: [],
    combustibles: [],
    infracciones: [],
    mantenimientoData: [],
    conductores: []
  });

  useEffect(() => {
    const loadData = async () => {
      try {
        setLoading(true);
        const data = await fetchDashboardData();
        setRawData(data);
      } catch (err) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    loadData();
  }, []);

  return { rawData, loading, error };
};